import { Dispatch } from 'react';

import { ISelectOption } from 'common/components/MulltipleSelectCheckmarks/MultipleSelectCheckmarks';
import { MODULE_NAME, TASKTYPE } from 'common/constants';
import {
	setHorizonApplyFilterEnabled,
	setHorizonFilter,
	setHorizonFilterFlag,
	setHorizonSelectedAppliedFilterList,
	setShowAssignedToMe,
} from 'common/store/reducer/horizonScanReducer';
import {
	getDateStringFromISOString,
	getISODateString,
} from 'common/utils/utilFunctions';

import { relationshipDropDownValues } from 'features/RegulationInventory/RegInventoryUtils';
import { FilterParam } from 'features/RiskProfile/Taxonomy/RiskReferenceTaxonomy/RiskRefTaxonomy';

import { IExportColumnNames } from './api/type-def';
import {
	HORIZON_PROGRESS_BAR_ELEMENTS,
	RELATED_OBJECT_TYPE,
	HORIZON_EXPORT_COLUMNS,
} from './components/ActionPlanLayout/ActionPlanLayoutModules';

const { HORIZON } = RELATED_OBJECT_TYPE;
const { NOTSTARTED, APPLICABILITY_ASSESSMENT } = HORIZON_PROGRESS_BAR_ELEMENTS;
const { REACT_APP_ENVIRONMENT } = process.env;
const {
	CREATED_BY,
	AI_SUMMARY,
	JURISDICTION,
	LAST_REVISION_DATE,
	ONTOLOGY,
	TITLE,
	TYPE,
	REGULATORS,
	EFFECTIVE_DATE,
	LINK_URL,
} = HORIZON_EXPORT_COLUMNS;

export const horizonScanRelationList: any = [
	{
		value: 'obligation',
		label: 'Obligation',
	},
	...relationshipDropDownValues,
];

export const generatePayload = (
	type: string,
	value: string,
	data: any,
	obj: any,
) => {
	const utcDate = getISODateString(value);
	const utcEffectiveDate = getISODateString(
		getDateStringFromISOString(data?.effectiveDate ?? ''),
	);
	const utcReviewByDate = getISODateString(
		getDateStringFromISOString(data?.reviewByDate ?? ''),
	);
	if (data.taskId) {
		return {
			taskRequestList: [
				{
					id: data?.taskId,
					dueDate: type === 'dueDate' ? utcDate || '' : utcReviewByDate,
					assignedUserId: obj?.id || data?.assignedUserId || null,
					assignedObjectType: HORIZON,
					assignedObjectId: data.id,
					status:
						data.taskStatus?.toLowerCase() === NOTSTARTED?.toLowerCase()
							? APPLICABILITY_ASSESSMENT
							: data.taskStatus,
				},
			],
		};
	}
	return {
		taskRequestList: [
			{
				taskName: data.title,
				dueDate: type === 'dueDate' ? utcDate || '' : utcEffectiveDate,
				assignedUserId: obj?.id || null,
				assignedObjectType: HORIZON,
				assignedObjectId: data.id,
				status:
					data.taskStatus?.toLowerCase() === NOTSTARTED?.toLowerCase()
						? APPLICABILITY_ASSESSMENT
						: data.taskStatus,
				taskType: TASKTYPE.WORKFLOW,
				moduleName: MODULE_NAME.HORIZON_SCAN_NAME,
			},
		],
	};
};

export const getExportColumnNames = (data: IExportColumnNames) => {
	const {
		createdDate,
		aiSummary,
		jurisdiction,
		reviewByDate,
		ontology,
		title,
		type,
		linkURL,
		regulators,
		effectiveDate,
	} = data;

	const columns: ISelectOption[] = [
		{ label: title, value: TITLE },
		{ label: regulators, value: REGULATORS },
		{ label: linkURL, value: LINK_URL },
		{ label: reviewByDate, value: LAST_REVISION_DATE },
		{ label: createdDate, value: CREATED_BY },
		{ label: effectiveDate, value: EFFECTIVE_DATE },
		{ label: jurisdiction, value: JURISDICTION },
		{ label: type, value: TYPE },
		{ label: ontology, value: ONTOLOGY },
		{ label: aiSummary, value: AI_SUMMARY },
	];
	return columns;
};

export const getExportPayloadForHorizonScanning = (
	options: ISelectOption[],
	searchText: string,
	filters: any,
	totalRecordsCount: number,
	exportTypeName: string,
) => {
	const checkedOptions = options
		.filter((res) => res.checked)
		.map((res) => res.value);
	return {
		payload: {
			indexName: `horizon-scanning-${REACT_APP_ENVIRONMENT}`,
			searchText,
			filters,
			totalRecordsCount,
			export: {
				columns: checkedOptions,
				name: exportTypeName,
			},
		},
	};
};
interface IActivityFilter {
	label: string;
	value: string;
	checked: boolean;
	type: string;
}
export const handleClearFilter = (
	dispatch: Dispatch<any>,
	setUpdatedFilterData: (value: React.SetStateAction<FilterParam[]>) => void,
	setIsClearAllSelected: (value: React.SetStateAction<boolean>) => void,
	applyFilterEnabled: boolean,
	onlyActivityFilterFromFilter: IActivityFilter[],
) => {
	dispatch(setHorizonFilter(onlyActivityFilterFromFilter));
	dispatch(setHorizonSelectedAppliedFilterList(onlyActivityFilterFromFilter));
	setUpdatedFilterData([]);
	setIsClearAllSelected(true);
	dispatch(setShowAssignedToMe(false));
	if (applyFilterEnabled) {
		dispatch(setHorizonApplyFilterEnabled(false));
		dispatch(setHorizonFilterFlag(false));
	}
};
